import { User } from '../../app/types'

/**
 * Non-hook privilege check — usable in plain functions, render callbacks, and column definitions.
 *
 * Checks whether the user holds the given VpPrivilege.
 * _WRITE implies the corresponding _READ.
 *
 * Returns false when the user has no VpUser record (not provisioned).
 *
 * @param me        the current User from redux (nullable)
 * @param privilege a VpPrivilege name, e.g. 'SITE_DEVICES_READ'
 * @param siteId    optional siteId for site-scoped checks
 */
export function hasUserPrivilege(me: User | null | undefined, privilege: string, siteId?: string | null): boolean {
    if (!me) return false

    const vpPrivileges = me.vpPrivileges ?? []
    if (vpPrivileges.length === 0) return false

    // _WRITE implies _READ
    const privilegesToCheck = [privilege]
    if (privilege.endsWith('_READ')) {
        privilegesToCheck.push(privilege.replace(/_READ$/, '_WRITE'))
    }

    if (siteId) {
        const sitePrivileges = me.sitePrivileges ?? {}
        const wildcardPrivs = sitePrivileges['*'] ?? []
        const sitePrivs = sitePrivileges[siteId] ?? []
        return privilegesToCheck.some(p => wildcardPrivs.includes(p) || sitePrivs.includes(p))
    } else {
        return privilegesToCheck.some(p => vpPrivileges.includes(p))
    }
}


